import { useCallback } from 'react';
import { addBreadcrumb, captureException } from '@sentry/react';

import { useRecordPushNotificationEventsMutation } from '@ocx/graphql';
import { logInDev } from '@ocx/utils';

import { PushNotificationEventWithDeliveryId } from './push-notification-events.types';
import { mapPushNotificationEventToRecordPushNotificationEventInput } from './push-notification-events.utils';

export const useRecordPushNotificationEvents = () => {
  const [recordPushNotificationEvents] = useRecordPushNotificationEventsMutation({
    onCompleted: (result) => {
      const statsMessage = `Successfully: ${result.data.successCount}; Failed: ${result.data.failureCount}`;
      const logMessage = `[Push Notification Processing] Recording events to API completed. ${statsMessage}`;
      addBreadcrumb({ message: logMessage });
      logInDev(logMessage);

      if (result.data.failureCount > 0) {
        captureException(
          new Error(`[Push Notification Processing] Recording events to API completed with failures. ${statsMessage}`),
        );
      }
    },
    onError: (error) => {
      if (error.networkError) return;

      captureException(error);
      logInDev('[Push Notification Processing] Failed record events to API');
      logInDev(error);
    },
  });

  return useCallback(
    async (events: PushNotificationEventWithDeliveryId[]) => {
      addBreadcrumb({ message: '[Push Notification Processing] Start recording events to API' });
      await recordPushNotificationEvents({
        variables: {
          input: {
            events: events.map(mapPushNotificationEventToRecordPushNotificationEventInput),
          },
        },
      }).catch(logInDev);
    },
    [recordPushNotificationEvents],
  );
};
